module.exports = __webpack_public_path__ + "static/hkgrotesk-italic-6e0c778fb760affc0a3204968b622bdd.woff";